/**
 * place item in the correct order if necessary
 * @param item the last item in layer and the one to sort
 */
export function sortItem(item) {
    let before;
    for (let i = item.previousSibling; i; i = i.previousSibling) {
        if (item.data.id < i.data.id ||
            (item.data.id === i.data.id &&
                item.data.userEndpointId < i.data.userEndpointId)) {
            before = i;
        }
        else {
            break;
        }
    }
    if (before) {
        item.insertBelow(before);
    }
}
export var OPS;
(function (OPS) {
    OPS["MarkerCreated"] = "Sketch/MarkerCreated";
    OPS["ArrowCreated"] = "Sketch/ArrowCreated";
    OPS["Erased"] = "Sketch/Erased";
    OPS["Cleared"] = "Sketch/Cleared";
})(OPS || (OPS = {}));
export const type2ops = {
    arrow: OPS.ArrowCreated,
    path: OPS.MarkerCreated,
};
//# sourceMappingURL=utils.js.map